module.exports = __webpack_public_path__ + "media/theme/ico-plus-2-24129f2a.png";